import { Navigate, useLocation } from "react-router-dom";
import { ChartLineUp, GoogleLogo, Warning, LockKey } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const error = location.state?.error;

  if (!loading && user) return <Navigate to="/" replace />;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-background text-foreground">
      <section className="hidden lg:flex flex-col justify-between bg-slate-950 text-slate-50 p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.07] grid-bg" />
        <div className="relative flex items-center justify-between">
          <img src="/brand/logo-morrisopazo.png" alt="Morris & Opazo" className="h-7 w-auto" data-testid="login-brand-logo" />
          <span className="flex items-center gap-2 text-slate-400">
            <ChartLineUp size={18} weight="duotone" />
            <span className="font-heading font-extrabold tracking-tight text-sm">CASHFLOW<span className="text-emerald-400">.</span></span>
          </span>
        </div>
        <div className="relative max-w-xl" data-testid="login-description">
          <div className="label-xs text-slate-400">Forecast mensual · USD</div>
          <h1 className="font-heading text-4xl xl:text-5xl font-black tracking-tight mt-4 leading-[1.08]">
            Planifica, controla y proyecta tu flujo de caja con <span className="text-emerald-400">precisión.</span>
          </h1>
          <p className="mt-6 text-slate-300 text-base leading-relaxed">
            Una plataforma inteligente de planificación financiera que permite gestionar ingresos y egresos, actualizar proyecciones en tiempo real y comparar versiones del forecast, manteniendo una trazabilidad completa de cada cambio.
          </p>
          <p className="mt-4 text-slate-50 font-semibold border-l-2 border-emerald-400 pl-4">
            Anticipa resultados, toma mejores decisiones y mantén el control de tu liquidez.
          </p>
        </div>
        <div className="relative grid grid-cols-3 border-t border-slate-800 pt-6 font-mono-tabular text-xs text-slate-400">
          <span>V1 → V2 → V3</span><span>Diff %</span><span>CSV · XLSX · PDF</span>
        </div>
      </section>

      <section className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm" data-testid="login-card">
          <div className="lg:hidden mb-10">
            <img src="/brand/logo-morrisopazo.png" alt="Morris & Opazo" className="h-6 w-auto invert dark:invert-0" data-testid="login-brand-logo-mobile" />
            <p className="mt-6 font-heading text-xl font-extrabold tracking-tight">
              Planifica, controla y proyecta tu flujo de caja con precisión.
            </p>
            <p className="mt-2 text-sm text-muted-foreground">
              Anticipa resultados, toma mejores decisiones y mantén el control de tu liquidez.
            </p>
          </div>
          <div className="label-xs text-muted-foreground flex items-center gap-2"><LockKey size={12} /> Acceso restringido</div>
          <h2 className="font-heading text-3xl font-extrabold tracking-tight mt-2">Iniciar sesión</h2>
          <p className="text-sm text-muted-foreground mt-2">
            Entra con tu cuenta de Google. Solo pueden ingresar los correos que autorizó un administrador.
          </p>

          {error && (
            <div data-testid="login-error" className="mt-6 flex gap-2 items-start border border-red-200 bg-red-50 text-red-800 dark:border-red-900 dark:bg-red-950 dark:text-red-200 p-3 rounded-sm text-sm">
              <Warning size={16} weight="fill" className="mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <Button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="mt-8 w-full h-11 rounded-sm font-semibold btn-pulse"
          >
            <GoogleLogo size={18} weight="bold" className="mr-2" /> Continuar con Google
          </Button>
        </div>
      </section>
    </div>
  );
}
